import React from 'react';

interface SpinnerProps {
  small?: boolean;
  message?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ small = false, message }) => {
  const sizeClass = small ? 'w-5 h-5' : 'w-8 h-8';
  return (
    <div className="flex flex-col justify-center items-center my-4 space-y-4">
      <div className={`animate-spin rounded-full ${sizeClass} border-b-2 border-[var(--color-accent)]`}></div>
      {message && <p className="text-sm text-[var(--color-text-secondary)] text-center">{message}</p>}
    </div>
  );
};

export default Spinner;